import { ManageBondNumbers } from "@portal/components/admin/ManageBondNumbers";
import { IslandLayout } from "@portal/components/layout/IslandLayout";
import { AdminUserMenu } from "./AdminUserMenu";

export const ManageBondNumbersView = () => {
	return (
		<IslandLayout userMenu={<AdminUserMenu />}>
			<div className="flex flex-col gap-[30px] w-[1000px] max-w-[1000px] h-fit mt-[25px] mx-[40px] pb-[75px]">
				<span
					data-testid="manage-bond-numbers-label"
					className="text-[26px] text-primary font-semibold"
				>
					Manage Bond Numbers
				</span>
				<ManageBondNumbers />
			</div>
		</IslandLayout>
	);
};
